import { ComponentProps, ReactNode } from "react";
import { AlertCircle, Check } from "react-feather";
import { FeedbackContainer, FeedbackMessage } from "./styles";

interface InputFeedbackProps extends ComponentProps<typeof FeedbackContainer> {
  type?: "error" | "success" | "core";
  variant?: "system" | "core";
  message: string;
}

export default function InputFeedback({ type, variant, message, ...props }: InputFeedbackProps) {
  return (
    <FeedbackContainer type={type} variant={variant} {...props}>
      {type &&
        {
          success: <Check size={14} />,
          error: <AlertCircle size={14} />,
          core: null,
        }[type]}
      <FeedbackMessage>{message}</FeedbackMessage>
    </FeedbackContainer>
  );
}
